export default "__VITE_ASSET__BN0Es8gJ__"